/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/
// auth::api
import * as Api from './api'
// lodash - https://lodash.com/
import _ from 'lodash'

/*******************************************************************************
 * Services
 ******************************************************************************/

/*******************************************************************************
 * Configuration
 ******************************************************************************/

/*******************************************************************************
 * Transformer prototypes
 ******************************************************************************/

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/**
 * general success
 *
 * @param {obj} data
 * @return {obj} le data
 */
const _onSuccess = data => {

    if( _.get( data, 'data.data' ) ) {
        return _.get( data, 'data.data' )
    }

    return data

}

/**
 * general fail
 *
 * @param {obj} error from a server
 * @return {obj} the error
 */
const _onFailed = error => new Promise(( resolve, reject ) => {

    let error_obj = error.hasOwnProperty( 'response' ) ? error.response : error

    //reject( _.get( error_obj, 'data', null ) || error_obj )

    reject(error_obj)

})

/*******************************************************************************
 * Public methods
 *******************************************************************************

/**
 * get this auctioneer's sale-codes
 *
 * @return {promise}
 */
export const getSaleCodes = async (auctioneer_id, params = []) =>
    Api.getSaleCodes(auctioneer_id, params)
        .then( _onSuccess )
        .catch( _onFailed )

export const getSaleSections = async (auctioneer_id, params = []) =>
    Api.getSaleSections(auctioneer_id, params)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * get the individual auctioneer
 * @param {int} auctioneer_id 
 * @returns 
 */
export const show = async auctioneer_id =>
    Api.show(auctioneer_id)
        .then( _onSuccess )
        .catch( _onFailed )

export const publicShow = async auctioneer_id =>
    Api.publicShow(auctioneer_id)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * get the default bidding interval rules for a given auctioneer
 * @param {int} auctioneer_id 
 * @returns 
 */
export const getBiddingIntervalRules = async (auctioneer_id, params) =>
    Api.getBiddingIntervalRules(auctioneer_id, params)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * delete an auctioneer rule
 * @param {int} auctioneer_id 
 * @param {int} rule_id 
 * @returns 
 */
export const deleteRule = async (auctioneer_id, rule_id) =>
    Api.deleteRule(auctioneer_id, rule_id)
        .then( _onSuccess )
        .catch( _onFailed )

export const createRule = async (auctioneer_id, payload) =>
    Api.createRule(auctioneer_id, payload)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * get the configurations for this auctioneer
 * @param auctioneer_id
 * @returns {Promise<obj>}
 */
export const getConfigurations = async auctioneer_id =>
    Api.getConfigurations(auctioneer_id)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * suggest an accoutn code
 * @param auctioneer_id
 * @returns {Promise<obj>}
 */
export const getSuggestedAccountCode = async auctioneer_id =>
    Api.getSuggestedAccountCode(auctioneer_id)
        .then( _onSuccess )
        .catch( _onFailed )


/**
 * get the users associated to a given auctioneer by id
 * @param auctioneer_id
 * @param params
 * @returns {Promise<obj>}
 */
export const users = async (auctioneer_id, params = []) =>
    Api.users(auctioneer_id, params)
        .then( _onSuccess )
        .catch( _onFailed )

export const locations = async auctioneer_id =>
    Api.locations(auctioneer_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const updateLocation = async (auctioneer_id, location_id, data) =>
    Api.updateLocation(auctioneer_id, location_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const createLocation = async (auctioneer_id, data) =>
    Api.createLocation(auctioneer_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const assignLocation = async (auctioneer_id, location_id) =>
    Api.assignLocation(auctioneer_id, location_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const upsertConfiguration = async (auctioneer_id, payload) =>
    Api.upsertConfiguration(auctioneer_id, payload)
        .then(_onSuccess)
        .catch(_onFailed)

export const getConnections = async auctioneer_id =>
    Api.getConnections(auctioneer_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const update = async (auctioneer_id, data) =>
    Api.update(auctioneer_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

/**
 * get all the organisations currently associated to this auctioneer
 * @param auctioneer_id
 * @param params
 * @returns {Promise<obj>}
 */
export const getAssociatedOrganisations = async (auctioneer_id, params) =>
    Api.getAssociatedOrganisations(auctioneer_id, params)
        .then(_onSuccess)
        .catch(_onFailed)

/**
 * get a specific account associated to this auctioneer
 * @param auctioneer_id
 * @param account_id
 * @returns {Promise<obj>}
 */
export const getAccount = async (auctioneer_id, account_id) =>
    Api.getAccount(auctioneer_id, account_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const getAccountConfigurations = async (auctioneer_id, account_id) =>
    Api.getAccountConfigurations(auctioneer_id, account_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const upsertAccountConfigurations = async (auctioneer_id, account_id, data) =>
    Api.upsertAccountConfigurations(auctioneer_id, account_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

// export const getAccountLocations = async (auctioneer_id, account_id) =>
//     Api.getAccountLocations(auctioneer_id, account_id)
//         .then(_onSuccess)
//         .catch(_onFailed)